export const isTaskDone = (t) => t.status === "done" || (t.percent_complete || 0) >= 100;

const clampPct = (t) => Math.min(100, Math.max(0, t.percent_complete || 0));

// Default ("partial"): average of each task's % complete — partial progress counts.
// "effort": partial progress weighted by effort days. "done": completed / all tasks.
export const progressPct = (tasks, style) => {
  const list = tasks || [];
  if (!list.length) return 0;
  if (style === "done") {
    return Math.round((list.filter(isTaskDone).length / list.length) * 100);
  }
  if (style === "effort") {
    let w = 0, ws = 0;
    for (const t of list) {
      if (t.is_summary) continue;
      const eff = t.effort_days != null ? Number(t.effort_days) : Number(t.duration_days || 1);
      w += eff;
      ws += clampPct(t) * eff;
    }
    return w ? Math.round(ws / w) : 0;
  }
  const basis = list.filter((t) => !t.is_summary);
  const src = basis.length ? basis : list;
  return Math.round(src.reduce((a, t) => a + clampPct(t), 0) / src.length);
};
